
import {Header} from './Header';

export default {
    title: 'Navigation/Header',
    component: Header,
    tags: ['autodocs'],
    parameters: {
        layout: 'fullscreen',
    },
}

const menuItems = {
    cart_count: '',
    links: [
        { title: 'Item 1', url: '/item1', handle:'' },
        { title: 'Item 2', url: '/item2' , handle:'' },
    ]
}

export const Default = {
    args: {
        links: menuItems.links,
        cart_count: 1,
        settings: {
            logo: 'http://mindarc-integrations.myshopify.com/cdn/shop/files/logo.png?v=1707803960',
            shop_title: 'Arctheme',
        },
        type: 'header-layout-left',
    },
};

export const Centered = {
    args: {
        links: menuItems.links,
        cart_count: 1,
        settings: {
            logo: 'http://mindarc-integrations.myshopify.com/cdn/shop/files/logo.png?v=1707803960',
            shop_title: 'Arctheme',
        },
        type: 'header-layout-center',
    },
};
